"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _utils = require("../InputBase/utils");
var _createStyles = require("../styles/createStyles");
var _isDsElement = _interopRequireDefault(require("../utilities/isDsElement"));
var _FormControlContext = _interopRequireDefault(require("./FormControlContext"));
const _excluded = ["children", "classes", "className", "component", "disabled", "error", "expanded", "fullWidth", "hasPlaceholder", "required", "variant", "size"];
const useStyles = exports.useStyles = (0, _createStyles.createStyles)(() => ({
  /* Styles applied to the root element. */
  root: {
    display: 'inline-flex',
    flexDirection: 'column',
    position: 'relative',
    // Reset fieldset default style.
    minWidth: 0,
    padding: 0,
    margin: 0,
    border: 0,
    verticalAlign: 'top' // Fix alignment issue on Safari.
  },
  /* Styles applied to the root element if `fullWidth={true}`. */
  fullWidth: {
    width: '100%'
  }
}));
/**
 * **❗️ DEPRECATED**: Use the new form components from `@busbud/horizon`.
 *
 * [Storybook](https://busbud.github.io/design-system/?path=/docs/components-inputs-textfield--page)
 *
 * Provides context such as filled/focused/error/required for form inputs. Relying on the context provides high flexibility and ensures that the state always stays consistent across the children of the FormControl.
 * This context is used by the following components:
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 *
 * [Storybook](https://busbud.github.io/design-system/?path=/docs/components-api-formcontrol--page)
 *
 * @deprecated
 */
const FormControl = /*#__PURE__*/_react.default.forwardRef(function FormControl(props, ref) {
  const {
      children,
      classes: classesOverrides,
      className,
      component: Component = 'div',
      disabled = false,
      error = false,
      expanded = false,
      fullWidth = false,
      hasPlaceholder = false,
      required = false,
      variant = 'filled',
      size = 'md'
    } = props,
    other = (0, _objectWithoutProperties2.default)(props, _excluded);
  const {
    classes,
    cx
  } = useStyles({
    classesOverrides
  });
  const [filled, setFilled] = _react.default.useState(() => {
    // We need to iterate through the children and find the Input in order
    // to fully support server-side rendering.
    let initialFilled = false;
    if (children) {
      _react.default.Children.forEach(children, child => {
        if (!(0, _isDsElement.default)(child, ['Input', 'Select'])) {
          return;
        }
        if ((0, _utils.isFilled)(child.props, true)) {
          initialFilled = true;
        }
      });
    }
    return initialFilled;
  });
  const [focused, setFocused] = _react.default.useState(false);
  if (disabled && focused) {
    setFocused(false);
  }
  let registerEffect;
  if (process.env.NODE_ENV !== 'production') {
    const registeredInput = _react.default.useRef(false);
    registerEffect = () => {
      if (registeredInput.current) {
        console.error(['There are multiple InputBase components inside a FormControl.', 'This is not supported. It might cause infinite rendering loops.', 'Only use one InputBase.'].join('\n'));
      }
      registeredInput.current = true;
      return () => {
        registeredInput.current = false;
      };
    };
  }
  const onFilled = _react.default.useCallback(() => {
    setFilled(true);
  }, []);
  const onEmpty = _react.default.useCallback(() => {
    setFilled(false);
  }, []);
  const childContext = {
    hasPlaceholder,
    disabled,
    error,
    expanded,
    filled,
    focused,
    onBlur: () => {
      setFocused(false);
    },
    onEmpty,
    onFilled,
    onFocus: () => {
      setFocused(true);
    },
    registerEffect,
    required,
    size,
    variant
  };
  return /*#__PURE__*/_react.default.createElement(_FormControlContext.default.Provider, {
    value: childContext
  }, /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
    className: cx(classes.root, {
      [classes.fullWidth]: fullWidth
    }, className),
    ref: ref
  }, other), children));
});
var _default = exports.default = FormControl;